module.exports = __webpack_public_path__ + "images/flyer2-a77358b4938bec6460dbc5980e8f9999.jpg";